export class FormValidation {
    static phoneRules = v => {
        if (v) {
            if(v.length !== 14) {
                return "Phone number must have 10 digits";
            }
            else {
                return /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/.test(v);
            }
        }
        else {
            return true;
        }
    }

    static appCodeRules = v => {
        if (v) {
            if(v.length !== 6) {
                return "App Code must have 6 digits";
            }
            else {
                return /^\d{6}$/.test(v);
            }
        }
        else {
            return true;
        }
    }
}